import { Fragment } from 'react';

export type BreadcrumbComponent = React.ComponentType<{ isLast: boolean }>;

type FlyBreadcrumbsProps = {
  breadcrumbs: BreadcrumbComponent[];
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'children' | 'className'>;

export function FlyBreadcrumbs({ breadcrumbs, ...rest }: FlyBreadcrumbsProps) {
  return (
    <div
      data-testid='fly-breadcrumbs'
      {...rest}
      className='min-h-6 flex w-full items-start gap-fly-2 text-size-fly-3'
    >
      <div
        data-testid='fly-breadcrumbs-list'
        className='flex w-full items-center gap-fly-2'
      >
        {breadcrumbs.map((Breadcrumb, index) => (
          <Fragment key={index}>
            <Breadcrumb isLast={index === breadcrumbs.length - 1} />
            {index !== breadcrumbs.length - 1 && (
              <span
                data-testid='fly-breadcrumb-separator'
                className='px-[3px] opacity-72'
              >
                /
              </span>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
